module.exports = __webpack_public_path__ + "static/media/sawshark.18d36988.png";